$(function () {
	$('.popup_image_farm1').magnificPopup({
		delegate: 'a',
		type: 'image',
		mainClass: 'mfp-fade',
		removalDelay: 500,
		preloader: false,
		gallery: {
			enabled: true
		}
	});

	$('.popup_image_farm2').magnificPopup({
		delegate: 'a',
		type: 'image',
		mainClass: 'mfp-fade',
		removalDelay: 500,
		preloader: false,
		gallery: {
			enabled: true
		}
	});

	$('.popup_image_farm3').magnificPopup({
		delegate: 'a',
		type: 'image',
		mainClass: 'mfp-fade',
		removalDelay: 500,
		preloader: false,
		gallery: {
			enabled: true
		}
	});

	$('.popup-movie').magnificPopup({
		type: 'iframe',
		iframe: {
			patterns: {
				youtube: {
					index: 'youtube.com',
					id: 'v=',
					src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
				}
			}
		}
	});
});
